import { observer } from 'mobx-react';
import React from 'react';
import { MembershipsCard } from './memberships';
import { ProductFlagsCard } from './product-flags-card';
import { UserAppAccessCard } from './user-app-access-card';
import { UserAppsCard } from './user-apps-card';
import { UserTypeCard } from './user-type-card';

export const UserDetails = observer(() => (
    <div className="flex max-w-5xl flex-col gap-6">
        <UserTypeCard />
        <MembershipsCard />
        <ProductFlagsCard />
        <UserAppsCard />
        <UserAppAccessCard />
    </div>
));

export default UserDetails;
